'use strict';

import Loader from '../loader/loader';
import '../../_assets/abbott/js/_modernizr';
import { isFieldEmpty, isValidEmail, displayErrors } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class StaffShopNewAccount {
    constructor() {
        let $body = $('body'),
            $adminNewAccountDropdown = $('.staffshop-new-account__dropdown'),
            $staffUploadDropdown = $('.staffshop-upload__dropdown');
        
        let $firstName = $adminNewAccountDropdown.find('input[name=FirstName]'),
            $lastName = $adminNewAccountDropdown.find('input[name=LastName]'),
            $company = $adminNewAccountDropdown.find('select[name=InstitutionId]'),
            $email = $adminNewAccountDropdown.find('input[name=EmailAddress]'),
            $primaryNumber = $adminNewAccountDropdown.find('input[name=MobileNumber]'),
            $uploadCompany = $staffUploadDropdown.find('input[name=UploadCompany]'),
            $uploadFile = $staffUploadDropdown.find('input[name=StaffShopFile]'),
            $uploadAnalysis = $(".upload-analysis"),
            $uploadConfirmCta = $(".confirm-cta-holder"),
            $mobileNumber = $('#EditMobileNumber'),
            $formMyProfile = $('#update-abbott-admin-form'),
            $staffShopUserId = $('#StaffShopUserId'),
            loader = new Loader(),
            _isInvalid = [],
            dataParams = {};

        $(".js-upload-ssu").on("click", function(e){
            e.preventDefault();
            $uploadConfirmCta.addClass("hidden");
            $staffUploadDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        });

        $('.js-staffshop-my-profile').on('click', function(e){
            e.preventDefault();
            $('.staffshop-myprofile__dropdown').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        })

        let getUploadFormData = function($this){
            // Define where to display ajax errors
            _isInvalid = [];

            if (isFieldEmpty($uploadCompany)) {
                $uploadCompany
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($uploadFile)) {
                $uploadFile
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (_isInvalid.length > 0) {
                $this.addClass('error');
                return false;
            } else {
                _isInvalid = [];

                loader.fadeIn();
                $this.removeClass('error');
            }

            var data = new FormData();

            var files = $uploadFile.get(0).files;

            // Add the uploaded image content to the form data collection
            if (files.length > 0) {
                data.append("StaffShopFile", files[0]);
            }

            var instituteId = $uploadCompany.data("value");
            data.append("InstituteId",instituteId);
            return data;
        }

        $('.js-upload-ssu-preview').on('click', function (e) {
            e.preventDefault();

            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');
            let data = getUploadFormData($(this));

            $.ajax({
                url: '/api/staffshop/previewupload',
                type: 'POST',
                headers: { __RequestVerificationToken: $staffUploadDropdown.find('input[name=__RequestVerificationToken]').val() },
                contentType: false,
                processData: false,
                data: data,
                success: function (result) {
                    toaster('Upload preview has been completed!');
                    loader.fadeOut();
                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });
                    $(".upload-analysis").html(`<p><strong>Upload preview analysis</strong></p>
                        <ul>
                            <li>New users: ${result.UsersToAdd.length}</li>
                            <li>Deactivate users: ${result.UsersToDeactivate.length}</li>
                            <li><strong>Total active users after the upload will be: ${result.ActiveUsers.length}</strong></li>
                        </ul>
                        <p>
                            <strong>Please ensure the above is accurate before clicking the confirm button below.</strong>
                        </p>
                    `);
                    $uploadConfirmCta.removeClass("hidden");
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer);
                }
            });

        });

        $('.js-upload-ssu-confirm').on('click', function (e) {
            e.preventDefault();

            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');
            let data = getUploadFormData($(this));

            $.ajax({
                url: '/api/staffshop/upload',
                type: 'POST',
                headers: { __RequestVerificationToken: $staffUploadDropdown.find('input[name=__RequestVerificationToken]').val() },
                contentType: false,
                processData: false,
                data: data,
                success: function (data) {
                    toaster('Users uploaded successfully!');
                    loader.fadeOut();
                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });
                    $staffUploadDropdown.find('.js-collapse-form-modal').trigger('click');
                    window.location.reload();
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer);
                }
            });
        });

        $('.js-add-new-ssu').on('click', function (e) {
            e.preventDefault();

            $adminNewAccountDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        });

        $('.js-create-new-ssu').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            _isInvalid = [];

            if (isFieldEmpty($firstName)) {
                $firstName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($lastName)) {
                $lastName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($company)) {
                $company
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($email) || !isValidEmail($email.val())) {
                $email
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                loader.fadeIn();
                $(this).removeClass('error');
            }


            dataParams = {
                "Details":{
                    "FirstName": isFieldEmpty($firstName) == true ? null : $firstName.val(),
                    "LastName": isFieldEmpty($lastName) == true ? null : $lastName.val(),
                    "InstitutionId": isFieldEmpty($company) == true ? null : $company.val(),
                    "MobileNumber": isFieldEmpty($primaryNumber) == true ? null : $primaryNumber.val(),
                    "EmailAddress": isFieldEmpty($email) == true ? null : $email.val()
                }
            };

            $.ajax({
                url: '/api/staffshop/create',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                headers: { __RequestVerificationToken: $adminNewAccountDropdown.find('input[name=__RequestVerificationToken]').val() },
                data: JSON.stringify(dataParams),
                success: function (data) {
                    toaster('Account details hav been saved!');
                    window.location.href = data.href;
                   
                    loader.fadeOut();

                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });

                    $adminNewAccountDropdown.find('.js-collapse-form-modal').trigger('click');
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });
        });

        $('.js-save-update-account-ssu').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            _isInvalid = [];

            if (isFieldEmpty($mobileNumber)) {
                $mobileNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            } else {
                $mobileNumber
                    .parent().removeClass('incomplete')
                    .find('.error').slideUp({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });
            }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                loader.fadeIn();
                $(this).removeClass('error');
            }


            dataParams = {
                "StaffId": $staffShopUserId.val(),
                "MobileNumber": $mobileNumber.val()
            };

            $.ajax({
                url: '/api/staffshop/updateprofile',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                headers: { __RequestVerificationToken: $formMyProfile.find('input[name=__RequestVerificationToken]').val() },
                data: JSON.stringify(dataParams),
                success: function (data) {
                    toaster('Your profile has been saved!');
                    window.location.href = window.location.href;
                    loader.fadeOut();

                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });
        });
    }
}
